export class OneboxMaxResults {
  editable = false;
  id = '';
  value = '';
}
